// extracted by mini-css-extract-plugin
export default {"payment-header":"t7Pp4","paymentHeader":"t7Pp4"};